import { render, staticRenderFns } from "./AttendanceSetting.vue?vue&type=template&id=dff96e32&scoped=true"
import script from "./AttendanceSetting.vue?vue&type=script&lang=js"
export * from "./AttendanceSetting.vue?vue&type=script&lang=js"
import style0 from "./AttendanceSetting.vue?vue&type=style&index=0&id=dff96e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff96e32",
  null
  
)

export default component.exports